package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_01_27_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes as they are alerted by Caper and Tuesday during the 4th night watch that a small group of Gnolls have been sighted. The Gnolls are out matched as the heroes easily slay them without a single Gnoll entering melee range. Caper suggests that we bury the Gnolls' corpses and mark the burial site(s) with (a) cairn(es).  Annette and Caper were wounded during the gnoll attack, so the party takes a short rest. After the rest and breakfast, the party continues north north west. Gorem leads the way through the rain. Our heroes find 3 animal carcasses (rabbit, fox) and a path. Around noon or 1pm, our heroes see what looks like humans trying to sneak.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("2/03/2023 11th of Newgrowth Our heroes have spotted what they believe are some of the cultists who are dicks to animals.  These humanoids are wearing leather armor and are dirty.  Our heroes kill the visible cultists, leaving one prisoner who they interrogate.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The cultists appears to have taken a vow of poverty as they are all poorly dressed and have no possessions or money.  They worship Sklyx who “will kill you all.” (According to a cultist) The captured cultist tells the heroes that")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("[Skylx] is a demon that will consume [them] all")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("[Skylx] is never far from here")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("… lives to the north east")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Skylx is not a god known to our heroes. He could be influenced by an extra planar creature, devil, angel, or fae.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes take a long rest.")
    }
}
